
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';
import { testimonials } from '../../../mocks/products';

const youtubeChannels = [
  {
    name: '건강한 식탁',
    subscribers: '12.3만',
    image: 'https://public.readdy.ai/ai/img_res/fce9dd4c9cbdd53fea309361fc7f84a8.jpg',
    url: '#',
  },
  {
    name: '자연의 맛',
    subscribers: '8.7만',
    image: 'https://readdy.ai/api/search-image?query=korean%20male%20nutrition%20expert%20youtuber%20profile%20photo%20professional%20warm%20smile%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt2&orientation=squarish',
    url: '#',
  },
  {
    name: '엄마의 건강밥상',
    subscribers: '25.1만',
    image: 'https://readdy.ai/api/search-image?query=friendly%20korean%20middle%20aged%20woman%20cooking%20youtuber%20profile%20photo%20warm%20smile%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt3&orientation=squarish',
    url: '#',
  },
  {
    name: '헬시라이프',
    subscribers: '15.6만',
    image: 'https://readdy.ai/api/search-image?query=young%20korean%20fitness%20woman%20youtuber%20profile%20photo%20energetic%20smile%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt4&orientation=squarish',
    url: '#',
  },
  {
    name: '슈퍼푸드 연구소',
    subscribers: '6.2만',
    image: 'https://readdy.ai/api/search-image?query=korean%20male%20scientist%20superfood%20researcher%20youtuber%20profile%20photo%20glasses%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt5&orientation=squarish',
    url: '#',
  },
  {
    name: '오가닉 라이프',
    subscribers: '19.4만',
    image: 'https://readdy.ai/api/search-image?query=young%20korean%20woman%20organic%20lifestyle%20youtuber%20profile%20photo%20natural%20look%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt6&orientation=squarish',
    url: '#',
  },
  {
    name: '건강 브이로그',
    subscribers: '9.8만',
    image: 'https://readdy.ai/api/search-image?query=korean%20young%20man%20health%20vlogger%20youtuber%20profile%20photo%20casual%20smile%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt7&orientation=squarish',
    url: '#',
  },
  {
    name: '약선 요리',
    subscribers: '31.5만',
    image: 'https://readdy.ai/api/search-image?query=korean%20elderly%20woman%20traditional%20herbal%20cooking%20youtuber%20profile%20photo%20warm%20gentle%20smile%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt8&orientation=squarish',
    url: '#',
  },
  {
    name: '뉴트리션 톡',
    subscribers: '11.2만',
    image: 'https://readdy.ai/api/search-image?query=korean%20female%20nutritionist%20youtuber%20profile%20photo%20professional%20friendly%20smile%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt9&orientation=squarish',
    url: '#',
  },
  {
    name: '그린 키친',
    subscribers: '7.5만',
    image: 'https://readdy.ai/api/search-image?query=korean%20young%20man%20plant%20based%20chef%20youtuber%20profile%20photo%20bright%20smile%20clean%20background%20portrait%20circular%20avatar%20style&width=120&height=120&seq=yt10&orientation=squarish',
    url: '#',
  },
];

export default function Testimonials() {
  const { ref, isVisible } = useScrollAnimation();

  const colors = [
    'bg-emerald-100 text-emerald-600',
    'bg-amber-100 text-amber-600',
    'bg-rose-100 text-rose-600',
    'bg-sky-100 text-sky-600',
    'bg-violet-100 text-violet-600',
    'bg-teal-100 text-teal-600',
  ];

  return (
    <section className="py-14 md:py-24 px-5 md:px-8 bg-stone-50">
      <div ref={ref} className="max-w-7xl mx-auto">
        <div
          className={`text-center mb-8 md:mb-14 ${
            isVisible ? 'animate-fade-in-up' : 'opacity-0'
          }`}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-emerald-50 text-emerald-600 text-xs font-semibold mb-3 md:mb-4">
            고객 후기
          </span>
          <h2
            className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4"
            style={{ fontFamily: 'Noto Serif KR, serif' }}
          >
            고객들이 직접 경험한<br />
            <strong>건강한 변화</strong>
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
          {testimonials.map((review, index) => (
            <div
              key={review.id}
              className={`bg-white rounded-2xl p-5 md:p-6 shadow-sm hover-lift cursor-default ${
                isVisible ? 'animate-fade-in-up' : 'opacity-0'
              }`}
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="flex items-center gap-3 mb-3 md:mb-4">
                <div
                  className={`w-9 h-9 md:w-10 md:h-10 rounded-full flex items-center justify-center text-xs md:text-sm font-bold ${colors[index % colors.length]}`}
                >
                  {review.avatar}
                </div>
                <div>
                  <p className="text-xs md:text-sm font-bold text-gray-900">{review.name}</p>
                  <p className="text-[10px] md:text-xs text-gray-400">@{review.product}</p>
                </div>
              </div>
              <div className="flex items-center gap-0.5 mb-2 md:mb-3">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i
                    key={i}
                    className={`ri-star-fill text-[10px] md:text-xs w-3 h-3 flex items-center justify-center ${
                      i < review.rating ? 'text-amber-400' : 'text-gray-200'
                    }`}
                  />
                ))}
              </div>
              <p className="text-xs md:text-sm text-gray-600 leading-relaxed">
                &ldquo;{review.text}&rdquo;
              </p>
            </div>
          ))}
        </div>

        {/* YouTube 채널 아이콘 섹션 */}
        <div
          className={`mt-12 md:mt-16 text-center ${
            isVisible ? 'animate-fade-in-up' : 'opacity-0'
          }`}
          style={{ animationDelay: '600ms' }}
        >
          <span className="inline-block px-4 py-1.5 rounded-full bg-red-50 text-red-500 text-xs font-semibold mb-3">
            <i className="ri-youtube-fill w-4 h-4 inline-flex items-center justify-center mr-1" />
            유튜브 리뷰어
          </span>
          <p className="text-xs md:text-sm text-gray-500 mb-6 md:mb-8">
            콩이사랑 제품을 소개해 주신 유튜브 크리에이터분들
          </p>

          <div className="grid grid-cols-5 gap-x-4 gap-y-6 md:gap-x-8 md:gap-y-8 max-w-3xl mx-auto">
            {youtubeChannels.map((channel, index) => (
              <a
                key={channel.name}
                href={channel.url}
                rel="nofollow"
                className={`group flex flex-col items-center gap-1.5 md:gap-2 ${
                  isVisible ? 'animate-fade-in-up' : 'opacity-0'
                }`}
                style={{ animationDelay: `${700 + index * 80}ms` }}
              >
                <div className="relative w-12 h-12 md:w-[72px] md:h-[72px] rounded-full overflow-hidden ring-2 ring-gray-100 group-hover:ring-red-400 transition-all duration-300 group-hover:scale-110 group-hover:shadow-lg group-hover:shadow-red-100">
                  <img
                    src={channel.image}
                    alt={channel.name}
                    className="w-full h-full object-cover object-top rounded-full transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 rounded-full bg-red-500/0 group-hover:bg-red-500/10 transition-colors duration-300 flex items-center justify-center">
                    <i className="ri-youtube-fill text-white text-sm md:text-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-4 h-4 md:w-5 md:h-5 flex items-center justify-center drop-shadow-md" />
                  </div>
                </div>
                <div className="flex flex-col items-center gap-0.5">
                  <span className="text-[10px] md:text-xs text-gray-700 group-hover:text-red-500 transition-colors duration-300 font-semibold whitespace-nowrap">
                    {channel.name}
                  </span>
                  <span className="text-[9px] md:text-[10px] text-gray-400 group-hover:text-red-400 transition-colors duration-300 hidden sm:block">
                    구독자 {channel.subscribers}
                  </span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
